import React from 'react'

import { get } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectGroups } from 'store/prospects'

import MainTabItem from '../components/MainTabItem'

/**
 * This component configures a MainTabItem with badgeContent for MyColleges
 * @param {object} props
 * @prop {number} suggestedCount
 * @prop {string} title
 * @prop {string} label
 * @returns MyCollegesTabItem
 */
const MyCollegesTabItem = ({ suggestedCount, title, label, ...rest }) => {
  const baseLabel = label?.trim() || title?.trim() || ''
  const suffix = suggestedCount > 0 ? ` - ${suggestedCount} Suggestion${suggestedCount === 1 ? '' : 's'}` : ''
  const computedLabel = baseLabel + suffix
  return (
    <MainTabItem
      title={title}
      badgeContent={suggestedCount}
      label={computedLabel}
      {...rest}
    />
  )
}

MyCollegesTabItem.propTypes = {
  suggestedCount: PropTypes.number,
  title: PropTypes.string.isRequired,
  label: PropTypes.string,
}

export default connect((state) => {
  const groups = selectGroups(state)
  const suggested = get(groups, 'suggested', [])
  const suggestedCount = suggested.length
  return { suggestedCount }
})(MyCollegesTabItem)
